import { toTitleCaps } from '~/common/helpers/title_caps'

window.titleCaps = toTitleCaps
